import http from 'utils/http';

export const fetchOrdersReport = ({ query, page }) => http.get(`v1/organizations/{{organizationId}}/reporting/orders/?page=${page}&${query}`).then((res) => res.data);
